import { number, string, table } from "@rocicorp/zero";

export const vehicleAssignment = table("vehicleAssignments")
	.from("vehicle_assignments")
	.columns({
		id: string(),
		crewId: string().from("crew_id"),
		planId: string().from("plan_id"),
		vehicleId: string().from("vehicle_id"),
		createdBy: string().from("created_by"),
		createdAt: number().from("created_at"),
		// The plan's organisation, named by the mutators rather than left to the default.
		orgId: string().from("org_id"),
	})
	.primaryKey("id");
